// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Classify_Section {
    display: flex;
    flex-direction: column;
    padding: 20px;
    width: 100%;
    gap: 24px;
}

.Classify_Header {
    display: flex;
    margin-top: 10px;
    justify-content: space-between;
}

.Classify_Header>span {
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
    color: #000000;
}

.Classify_Upload {
    width: 132px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #EDF3F2;
    border-radius: 8px;
}

.Classify_Upload>span {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #38514C;
}

.Classify_Identify {
    width: 132px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #E67817;
    border-radius: 8px;
   
}

.Classify_Identify>span {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
     color: #FFFFFF;
}

.Classify_Label {
    background: #FFFFFF;
    box-shadow: 0px 4px 16px rgba(148, 93, 63, 0.05);
    border-radius: 8px;
    width: 100%;
    height: 72px;
    display: flex;
    align-items: center;
    gap: 40px;
    justify-content: space-around;
}

.Classify_Label_Item {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
}

.Classify_Label_Item>.label {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #594F42;
}

.Classify_Label_Item>.value {
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
    color: #000000;
}

.Classify_Container {
    background: #FFFFFF;
    box-shadow: 0px 4px 16px rgba(148, 93, 63, 0.05);
    border-radius: 8px;
    height: 100%;
    margin-bottom: 10px;
}

.ClassificationContainer {
    display: flex;
    flex-direction: column;
    padding: 24px;
    height: 100%;
}

.ClassificationContainerHeader {
    display: flex;
    gap: 40px;
    align-items: center;
    border-bottom: 1px solid rgb(232, 223, 213, .5);
}

.classification_type {
    display: flex;
    gap: 10px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.classification_type>span {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #9A938A;
    margin-bottom: 10px;
}

.ClassificationImages {
    display: flex;
    flex-wrap: wrap;
    height: 100%;
    gap: 24px;
}

.ClassificationImages img {
    width: 192px;
    height: 192px;
    border-radius: 8px;
}

.ClassificationImages span {
    font-weight: 500;
    font-size: 14px;
    color: #594F42;
    line-height: 20px;
}

.classifyCount {
    font-weight: 500;
    font-size: 12px !important;
    line-height: 18px !important;
    color: #9A938A !important;
}

.classification_type_active {
    font-weight: 600 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    color: #3F3325 !important;
    border-bottom: 2px solid #FF8214;
}

.classification_type_active span {
    font-weight: 600 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    color: #3F3325 !important;
}

.LoaderParent {
    display: grid;
    position: relative;
    align-items: center;
}

.LoadContent {
    position: absolute;
    width: 100%;
}

.LoadMainContent>span {
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
    color: #3F3325;
    text-align: center;
}

.LoadNormalContent{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.LoadMainContent{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.LoadNormalContent>span {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #9A938A;
}`, "",{"version":3,"sources":["webpack://./src/CSS/Classify.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,WAAW;IACX,SAAS;AACb;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;;AAEtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;KAChB,cAAc;AACnB;;AAEA;IACI,mBAAmB;IACnB,gDAAgD;IAChD,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,gDAAgD;IAChD,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB","sourcesContent":[".Classify_Section {\n    display: flex;\n    flex-direction: column;\n    padding: 20px;\n    width: 100%;\n    gap: 24px;\n}\n\n.Classify_Header {\n    display: flex;\n    margin-top: 10px;\n    justify-content: space-between;\n}\n\n.Classify_Header>span {\n    font-weight: 600;\n    font-size: 24px;\n    line-height: 36px;\n    color: #000000;\n}\n\n.Classify_Upload {\n    width: 132px;\n    height: 40px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: #EDF3F2;\n    border-radius: 8px;\n}\n\n.Classify_Upload>span {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #38514C;\n}\n\n.Classify_Identify {\n    width: 132px;\n    height: 40px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #E67817;\n    border-radius: 8px;\n   \n}\n\n.Classify_Identify>span {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n     color: #FFFFFF;\n}\n\n.Classify_Label {\n    background: #FFFFFF;\n    box-shadow: 0px 4px 16px rgba(148, 93, 63, 0.05);\n    border-radius: 8px;\n    width: 100%;\n    height: 72px;\n    display: flex;\n    align-items: center;\n    gap: 40px;\n    justify-content: space-around;\n}\n\n.Classify_Label_Item {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n}\n\n.Classify_Label_Item>.label {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #594F42;\n}\n\n.Classify_Label_Item>.value {\n    font-weight: bold;\n    font-size: 14px;\n    line-height: 20px;\n    color: #000000;\n}\n\n.Classify_Container {\n    background: #FFFFFF;\n    box-shadow: 0px 4px 16px rgba(148, 93, 63, 0.05);\n    border-radius: 8px;\n    height: 100%;\n    margin-bottom: 10px;\n}\n\n.ClassificationContainer {\n    display: flex;\n    flex-direction: column;\n    padding: 24px;\n    height: 100%;\n}\n\n.ClassificationContainerHeader {\n    display: flex;\n    gap: 40px;\n    align-items: center;\n    border-bottom: 1px solid rgb(232, 223, 213, .5);\n}\n\n.classification_type {\n    display: flex;\n    gap: 10px;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n}\n\n.classification_type>span {\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 24px;\n    color: #9A938A;\n    margin-bottom: 10px;\n}\n\n.ClassificationImages {\n    display: flex;\n    flex-wrap: wrap;\n    height: 100%;\n    gap: 24px;\n}\n\n.ClassificationImages img {\n    width: 192px;\n    height: 192px;\n    border-radius: 8px;\n}\n\n.ClassificationImages span {\n    font-weight: 500;\n    font-size: 14px;\n    color: #594F42;\n    line-height: 20px;\n}\n\n.classifyCount {\n    font-weight: 500;\n    font-size: 12px !important;\n    line-height: 18px !important;\n    color: #9A938A !important;\n}\n\n.classification_type_active {\n    font-weight: 600 !important;\n    font-size: 16px !important;\n    line-height: 24px !important;\n    color: #3F3325 !important;\n    border-bottom: 2px solid #FF8214;\n}\n\n.classification_type_active span {\n    font-weight: 600 !important;\n    font-size: 16px !important;\n    line-height: 24px !important;\n    color: #3F3325 !important;\n}\n\n.LoaderParent {\n    display: grid;\n    position: relative;\n    align-items: center;\n}\n\n.LoadContent {\n    position: absolute;\n    width: 100%;\n}\n\n.LoadMainContent>span {\n    font-weight: 600;\n    font-size: 24px;\n    line-height: 36px;\n    color: #3F3325;\n    text-align: center;\n}\n\n.LoadNormalContent{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n}\n.LoadMainContent{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n}\n\n.LoadNormalContent>span {\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    text-align: center;\n    color: #9A938A;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
